export default {
  data: () => ({
    translations: {
      title_points: {
        el: 'Πόντοι ανά Προϊόν',
        en: 'Product Points',
        it: 'Punti Prodotto',
      },
      title_cashback: {
        el: 'Cashback ανά Προϊόν',
        en: 'Product Cashback',
        it: 'Cashback Prodotto',
      },
      info_points: {
        el: 'Καθορίστε τον αριθμό των πόντων που μπορούν να κερδίσουν οι πελάτες σας ανά προϊόν, καθώς και τον τρόπο ανταμοιβής πόντων. Μπορείτε επίσης να επιλέξετε για ποια προϊόντα να επιδοτούνται οι πόντοι (η επιδότηση σημαίνει ότι η μητρική σας εταιρεία θα καλύψει το κόστος χορήγησης πόντων στους πελάτες σας).',
        en: `
                    Specify the number of points that can be won per product. You can also choose whether you want these points to be subsidized or not (subsidized points mean that your parent company will cover the cost of granting points to your customers).
                `,
        it: 'Specificare il numero di punti che possono essere vinti per prodotto. Puoi anche scegliere se vuoi che questi punti siano sovvenzionati o meno (i punti sovvenzionati significano che la tua società madre coprirà il costo della concessione dei punti ai tuoi clienti).',
      },
      info_cashback: {
        el: 'Καθορίστε το ποσοστό επιστροφής χρημάτων που μπορούν να κερδίσουν οι πελάτες σας ανά προϊόν. Μπορείτε επίσης να επιλέξετε για ποια προϊόντα θα ισχύει η επιστροφή χρημάτων.',
        en: `
                    Specify the cashback percentage that can be won per product. You can also choose for which products the cashback will apply.
                `,
        it: 'Specificare la percentuale di cashback che può essere vinta per prodotto. Puoi anche scegliere per quali prodotti si applicherà il cashback.',
      },
      productName: {
        el: 'Όνομα Προϊόντος',
        en: 'Product Name',
        it: 'Nome del Prodotto',
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
      type: {
        el: 'Τύπος',
        en: 'Type',
        it: 'Tipo',
      },
      pointSubsidy: {
        el: 'Επιδότηση',
        en: 'Subsidy',
        it: 'Sussidio',
      },
      action: {
        el: 'Ενέργειες',
        en: 'Action',
        it: 'Azione',
      },
      noData: {
        el: 'Δεν υπάρχουν δεδομένα',
        en: 'No data available',
        it: 'Nessun dato disponibile',
      },
      subsidizedPoints: {
        el: 'Με Επιδότηση',
        en: 'Subsidized',
        it: 'Con sussidio',
      },
      change: {
        el: 'Αλλαγή',
        en: 'Change',
        it: 'Cambia',
      },
      perTransaction: {
        el: 'Ανά Συναλλαγή',
        en: 'Per Transaction',
        it: 'Per transazione',
      },
      perEuro: {
        el: 'Ανά Ευρω',
        en: 'Per Euro',
        it: 'Per Euro',
      },
      piece: {
        el: 'Ανά Τεμάχιο',
        en: 'Per Piece',
        it: 'Per pezzo',
      },
      liters: {
        el: 'Ανά Λίτρο',
        en: 'Per Liters',
        it: 'Per litro',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
    },
  }),
};
